import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { TabDocumentacionHce } from '../../../HCE/ListadoPacientes/ModalHce/TabDocumentacionHce';
import { useForm } from '../../../../hooks/useForm';
import { Box, Button, MenuItem, Select, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { traerEstudiosMedicos } from '../../../../actions/hce/hceActions';
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { armarParametros } from '../../../../helpers/parametros';
import { fetchConToken } from '../../../../helpers/fetch';
import { fetchEspecialidades } from '../../../../actions/especialidades';
import LoadingBeforeViewData from '../../../compartidos/LoadingBeforeViewData';
import { putEstudiosMedicos } from '../../../../actions/turnos/estudiosMedicos';
import { ESTUDIOS_MEDICOS_ESTADOS } from '../../../../utils/constants';


export const InformacionMenu = (props) => {

  const dispatch = useDispatch();
  const [listaEfectoresRed, setListaEfectoresRed] = useState([]);

  const { estudiosMedicos } = useSelector((state) => state.hce);
  const { estudioMedicoSeleccionado = {} } = useSelector(
    (state) => state.estudiosMedicos
  );
  const especialidades = useSelector((state) => state.especialidades);


  useEffect(() => {
    dispatch(traerEstudiosMedicos());
  }, [dispatch])

  useEffect(() => {
    dispatch(fetchEspecialidades(false))
  }, [dispatch]);


  let estudioMedicoDefault = {
    id: "",
    idEstudioMedico: "",
    idProblema: "",
    descripcionProblema: "",
    Description: "",
    idEfectorRedSolicitado: ""
  };

  const [
    formValues,
    handleInputChange,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    ,
  ] = useForm(
    !!estudioMedicoSeleccionado ? estudioMedicoSeleccionado : estudioMedicoDefault
  );

  const { idEstudioMedico, descripcion, idCentroMedico, idEfectorRedSolicitado, idEspecialidadEfectorRedSolicitado } = formValues



  useEffect(() => {

    const traerDatos = async () => {
      const parametros = armarParametros(idEspecialidadEfectorRedSolicitado, idCentroMedico, null, null, null, null, null, null, null);
      const response = props.porCentroMedico ? await fetchConToken(`EfectorP/traerPorCentroMedico?${parametros}`) : await fetchConToken(`EfectorP/traerPorEspecialidad?${parametros}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.ok && lista) {
          let listaFromApi = lista.map((item) => {
            return {
              value: item.idEfectorRed,
              display: item.nombreEfector,
            };
          });
          setListaEfectoresRed(listaFromApi);
        }
      }
    };
    traerDatos();
  }, [idEspecialidadEfectorRedSolicitado, idCentroMedico]);

  const EspecialidadesOptions = especialidades.items.map(item => ({
    value: item.idEspecialidades,
    label: item.descripcionEspecialidades,
  }));

  const onSubmitHandler = () => {
    dispatch(putEstudiosMedicos(formValues))
  }

  if (especialidades.cargada === false) {
    return <LoadingBeforeViewData />
  }


  console.log(formValues)

  return (
    <ValidatorForm onSubmit={onSubmitHandler} style={{ margin: "1rem 3rem" }}>
      <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          <TableRow>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "20%", whiteSpace: "nowrap" }}
              >
                Estudio:
              </TableCell>
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
              >
                {Array.isArray(estudiosMedicos) && estudiosMedicos?.length > 0 && (
                  <Select
                    style={{ width: "300px" }}
                    name="idEstudioMedico"
                    value={idEstudioMedico}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    disabled={false}
                  >
                    {Array.isArray(estudiosMedicos) &&
                      estudiosMedicos?.length > 0 &&
                      estudiosMedicos.map((est) => (
                        <MenuItem
                          key={est.id}
                          value={est.id}
                        >
                          {est.descripcion}
                        </MenuItem>
                      ))}
                  </Select>
                )}
              </TableCell>

            </Box>
          </TableRow>
          <TableRow>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "20%", whiteSpace: "nowrap" }}
              >
                Descripcion:
              </TableCell>
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
              >
                <TextValidator
                  fullWidth
                  margin="normal"
                  label=""
                  name="descripcion"
                  value={descripcion}
                />
              </TableCell>
            </Box>
          </TableRow>
          <TableRow>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "20%", whiteSpace: "nowrap" }}
              >
                Especialidad:
              </TableCell>
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
              >
                {Array.isArray(EspecialidadesOptions) && EspecialidadesOptions.length > 0 && (
                  <SelectValidator
                    fullWidth
                    label=""
                    name="idEspecialidadEfectorRedSolicitado"
                    value={idEspecialidadEfectorRedSolicitado}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    validators={['required']}
                    errorMessages={['Este campo es requerido']}
                  >
                    {EspecialidadesOptions.map((t, index) => (
                      <MenuItem key={index}
                        value={t.value}
                      >
                        {t.label}
                      </MenuItem>
                    ))}
                  </SelectValidator>
                )}
              </TableCell>
            </Box>
          </TableRow>
          <TableRow>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "20%", whiteSpace: "nowrap" }}
              >
                Asignado a:
              </TableCell>
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
              >

                <SelectValidator
                  fullWidth
                  label=""
                  name="idEfectorRedSolicitado"
                  value={idEfectorRedSolicitado}
                  onChange={(e) => {
                    handleInputChange(e);
                  }}
                  validators={['required']}
                  errorMessages={['Este campo es requerido']}
                >
                  {listaEfectoresRed.map((t, index) => (
                    <MenuItem key={index}
                      value={t.value}
                    >
                      {t.display}
                    </MenuItem>
                  ))}
                </SelectValidator>

              </TableCell>
            </Box>
          </TableRow>
        </TableBody>
      </Table>
      <TabDocumentacionHce estudioS={estudioMedicoSeleccionado} disabled={estudioMedicoSeleccionado?.idEstado === ESTUDIOS_MEDICOS_ESTADOS.PENDIENTES_ESTUDIO ? false : true}/>
      <div style={{ textAlign: "center", marginTop: "2.5rem" }}>
        <Button variant="contained" color="primary" type="submit">
          Guardar Cambios
        </Button>
      </div>
    </ValidatorForm>
  )
}
